import React, { useEffect } from 'react'

import { Fade, Slide } from 'react-animated-components'
import TagCloud from 'TagCloud';

import './AboutPage.css'

const container = '.content';
const texts = [
  'HTML', 'CSS', 'JAVASCRIPT',
  'AutoCAD', 'MONGOOSE', 'REACT',
  'SolidWorks', 'SASS',
  'MatLab', 'NODEJS', 'MONGODB',
  'EXPRESS', 'PLC', 'Arduino', 'Git'
];
const options = {
  radius: 250,
  // animation speed
  // slow, normal, fast
  maxSpeed: 'fast',
  initSpeed: 'fast',
  // 0 = top
  // 90 = left
  // 135 = right-bottom
  direction: 135,
  // interact with cursor move on mouse out
  keep: true
};

export default function AboutPage() {
  useEffect(() => {
    TagCloud(container, texts, options);
  })

  return (
    <Fade
      ref={{
        current: '[Circular]'
      }}
      onActive={function noRefCheck(){}}
      onComplete={function noRefCheck(){}}
    >
      <div className='AboutPage'>
        <div className='AboutPageLeft'>
          <h2 className='AboutTitle'>
            About <span>Me</span>
          </h2>
          <div className='AboutParagraphs'>
            <p>
              I'm very ambitious front-end developer looking for a role in established IT company with the opportunity to work with the latest technologies on challenging and diverse projects.
            </p>
            <p>
              I'm quietly confident, naturally curious, and perpetually working on improving my chops one design problem at a time.
            </p>
            <p>
              If I need to define myself in one sentence that would be a talented, artist and creative person, and tech-obsessed!!!
            </p>
          </div>
        </div>
        <div className="AboutPageRight">
          <Slide
            ref={{
              current: '[Circular]'
            }}
            direction="down"
            fade
            onActive={function noRefCheck(){}}
            onComplete={function noRefCheck(){}}
            wipe
          >
            <span className="content"></span>
          </Slide>
        </div>
      </div>
    </Fade>
  )
}
